import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import useValidateConversionDomain from '../hooks/useValidateConversionDomain'

import RadioBlock from '../../../../../../components/Form/RadioBlock'
import Field from '../../../../../../components/Form/Field'
import Button from '../../../../../../components/Button'
import { getAppDomainName } from '../../../../../../features/helpers/getAppDomainName'

import { selectedPartnershipSelector } from '../../../../../../modules/selectors/partnerships'

import {
  CUSTOM_URL_TAGS,
  NO_URL_TAGS,
  RECOMMENDED_URL_TAGS,
  URL_TAGS,
  URL_TAGS_OPTION,
  UTM_CAMPAIGN,
  UTM_CONTENT,
  UTM_MEDIUM,
  UTM_SOURCE
} from '../../../fields'

import { CHIP_COLORS } from '../../../../../../constants/other'

import useStyles from '../../../../../../styles/common/stepForms'

const UrlTagsStep = ({ formik, handleStepChange, isActive, adPreview, selectedApplicationId }) => {
  const { t } = useTranslation()
  const classes = useStyles()

  const { utm_medium: partnershipUtmMedium } = useSelector(selectedPartnershipSelector)
  const appName = getAppDomainName()

  const { values, setFieldValue } = formik

  const handleContinue = () => {
    handleStepChange()
  }

  useValidateConversionDomain({ values, isStepActive: isActive, selectedApplicationId })

  return (
    <>
      <div className={classes.stepTitle}>{t('Would you like to add UTM codes to your links?')}</div>
      <div className={classes.stepBody}>
        {adPreview && adPreview}
        <RadioBlock
          setFieldValue={setFieldValue}
          id="radio_tags_recommended"
          name={URL_TAGS_OPTION}
          value={RECOMMENDED_URL_TAGS}
          selectedValue={values[URL_TAGS_OPTION]}
          label={t('AdCreate.UrlTagsStep.recommendedOption.title', { appName })}
          badgeText={'Recommended'}
          badgeColor={CHIP_COLORS.success}
        >
          <div>
            <p>
              {t(
                'UTM codes are added to the click through link and allow you to track your website visits in analytics software such as Google Analytics.'
              )}
            </p>
            <p>{t('We will automatically add the following:')}</p>
            <p>
              'utm_source' = “Facebook”
              <br />
              'utm_medium' = “{partnershipUtmMedium || appName}”
              <br />
              'utm_campaign' = {t("This campaign's ID")}
              <br />
              'utm_content' = {t("This ad's name")}
            </p>
            <p>{t('If you’re not sure which option to pick, we recommend choosing this option.')}</p>
          </div>
        </RadioBlock>
        <RadioBlock
          setFieldValue={setFieldValue}
          id="radio_tags_custom"
          name={URL_TAGS_OPTION}
          value={CUSTOM_URL_TAGS}
          selectedValue={values[URL_TAGS_OPTION]}
          label={t('Yes, add custom UTM codes')}
        >
          <div>
            <p>
              {t(
                `Optionally, you can use the following variables below by typing them with curly brackets {{}}. These will be replaced with the id or name when the ad is created.`
              )}
            </p>
            <p>
              {'{{campaign.id}}'}
              <br />
              {'{{adset.id}}'}
              <br />
              {'{{ad.id}}'}
              <br />
              {'{{campaign.name}}'}
              <br />
              {'{{adset.name}}'}
              <br />
              {'{{ad.name}}'}
              <br />
            </p>
            <Field placeholder={t('UTM_SOURCE')} formik={formik} name={`${URL_TAGS}[${UTM_SOURCE}]`} />
            <Field placeholder={t('UTM_MEDIUM')} formik={formik} name={`${URL_TAGS}[${UTM_MEDIUM}]`} />
            <Field placeholder={t('UTM_CAMPAIGN')} formik={formik} name={`${URL_TAGS}[${UTM_CAMPAIGN}]`} />
            <Field placeholder={t('UTM_CONTENT')} formik={formik} name={`${URL_TAGS}[${UTM_CONTENT}]`} />
          </div>
        </RadioBlock>
        <RadioBlock
          setFieldValue={setFieldValue}
          id="radio_tags_none"
          name={URL_TAGS_OPTION}
          value={NO_URL_TAGS}
          selectedValue={values[URL_TAGS_OPTION]}
          label={t('No, don’t add UTM codes')}
        />
      </div>
      <div className={classes.stepFooter}>
        <Button type="button" className="dark" onClick={handleContinue}>
          {t('Continue')}
        </Button>
      </div>
    </>
  )
}

export default UrlTagsStep
